module.exports = __webpack_public_path__ + "img/gentlemen-club-carousel-34.8ab4de58.png";